import { Castle, Users, CalendarHeart, Flame } from "lucide-react";

const DISCORD_INVITE = "https://discord.gg/zWutaw6DR9";

export default function DragonsRoost() {
  return (
    <div className="page-container fade-in" data-testid="dragons-roost-page">
      <div className="page-eyebrow">the community</div>
      <h1 className="page-title">The Dragon's Roost</h1>
      <p className="page-sub">A warm cave high above the tavern where the regulars gather. Bring a snack, leave with friends.</p>

      <div className="grid lg:grid-cols-[1.2fr_1fr] gap-8 mt-10">
        <div className="parchment-card p-8 md:p-12 relative overflow-hidden">
          <span className="ornate-corner tl" /><span className="ornate-corner tr" />
          <span className="ornate-corner bl" /><span className="ornate-corner br" />

          <Castle className="h-10 w-10" style={{color:"var(--gold)"}} />
          <h2 className="tavern-heading text-3xl gold-text mt-3">Join the Roost on Discord</h2>
          <p className="mt-4 leading-relaxed" style={{color:"var(--muted)"}}>
            Stream chatter, game nights, lore discussions, photo dumps, and the occasional dragon meme.
            The community is small, welcoming, and somehow always awake when you need a friend.
          </p>

          <div className="mt-7 flex flex-wrap gap-3">
            <a href={DISCORD_INVITE} target="_blank" rel="noreferrer" className="gold-btn glow-pulse" data-testid="discord-cta">
              <Flame className="h-4 w-4" /> Step Inside the Roost
            </a>
            <span className="text-sm self-center" style={{color:"var(--orchid-light)"}} >be kind, be curious, be welcome</span>
          </div>

          <div className="grid sm:grid-cols-3 gap-3 mt-8">
            {[
              {icon: Users, label: "Friendly Community", text: "Mods on duty, kindness as rule one."},
              {icon: CalendarHeart, label: "Weekly Gatherings", text: "Game nights, watch parties, cozy hours."},
              {icon: Castle, label: "Future Features", text: "Member roles, lore archive, sub perks."},
            ].map((b,i) => (
              <div key={i} className="p-4 rounded-sm border" style={{borderColor:"rgba(212,175,55,0.22)", background:"rgba(0,0,0,0.2)"}}>
                <b.icon className="h-5 w-5" style={{color:"var(--gold)"}}/>
                <div className="tavern-heading mt-2" style={{color:"var(--silver)"}}>{b.label}</div>
                <div className="text-xs mt-1" style={{color:"var(--muted)"}}>{b.text}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="parchment-card p-6">
          <div className="page-eyebrow">house rules</div>
          <h3 className="tavern-heading text-2xl gold-text mt-1">A few simple things</h3>
          <ol className="mt-5 space-y-3 text-sm" style={{color:"var(--silver)"}}>
            <li className="flex gap-3"><span className="gold-text">I.</span> Be kind. We rebuild lanterns, not break them.</li>
            <li className="flex gap-3"><span className="gold-text">II.</span> Curiosity is welcome — even chaotic curiosity.</li>
            <li className="flex gap-3"><span className="gold-text">III.</span> No spam, no scams, no shouting.</li>
            <li className="flex gap-3"><span className="gold-text">IV.</span> Spoilers go behind tags. Always.</li>
            <li className="flex gap-3"><span className="gold-text">V.</span> Dragons get pets if they ask politely.</li>
          </ol>
        </div>
      </div>
    </div>
  );
}
